import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Logo } from "../../components/site/Logo";

export default function AdminLogin() {
  const { login } = useAuth();
  const location = useLocation();
  // A rejected Google sign-in comes back as a server redirect to
  // /admin/login?error=..., so read the query string as well as router state.
  const error =
    location.state?.error || new URLSearchParams(location.search).get("error");

  return (
    <div className="min-h-screen bg-void text-white flex items-center justify-center px-6 noise">
      <div className="pointer-events-none absolute inset-0 hero-lighting" />
      <div className="relative w-full max-w-md">
        <div className="flex justify-center mb-10">
          <Logo size={36} />
        </div>
        <div className="glass rounded-3xl p-8 md:p-10 text-center">
          <div className="font-mono text-xs uppercase tracking-[0.2em] text-brand mb-4">Admin access</div>
          <h1 className="font-heading text-3xl font-medium tracking-tight text-gradient">Sign in to continue</h1>
          <p className="mt-4 text-sm text-muted-foreground">
            Manage leads, content, and site settings. Access is restricted to authorized accounts.
          </p>

          {error && (
            <div data-testid="login-error" className="mt-6 rounded-xl border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm text-red-300">
              {error}
            </div>
          )}

          <button
            onClick={login}
            data-testid="google-login-btn"
            className="mt-8 w-full inline-flex items-center justify-center gap-3 rounded-xl bg-white text-gray-900 font-medium px-6 py-3.5 hover:bg-gray-100 transition-colors active:scale-[0.99]"
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.76h3.56c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.56-2.76c-.98.66-2.23 1.06-3.72 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09a6.6 6.6 0 0 1 0-4.18V7.07H2.18a11 11 0 0 0 0 9.86l3.66-2.84z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
            </svg>
            Sign in with Google
          </button>

          <a href="/" className="mt-6 inline-block text-xs text-muted-foreground hover:text-white transition-colors">
            ← Back to website
          </a>
        </div>
      </div>
    </div>
  );
}
